import {Injectable} from '@angular/core';
import {ApiVisa, BaseApiTemplateService, Core2Config} from '../shared';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import { PgwRequestModel} from '../../../../../models';

@Injectable({providedIn: 'root'})

export class PgwBackendService extends BaseApiTemplateService<any> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'pgw';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'pgw';
    this.httpClient = http;
  }

  browserToServerPgwRequest(request: PgwRequestModel, apiVisa: ApiVisa) : Observable<string> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }

    const queryString = Object.keys(request)
    .filter(key => {
      return request[key] !== undefined;
    })
    .map((key) => {
      return encodeURIComponent(key) + '=' + encodeURIComponent(request[key])
    }).join('&');

    const url = this.apiUrl + '/request/' + apiVisa.tenantCode +'?'+queryString;
    return this.httpClient.post<string>(
      url,
      request,
      this.getHttpHeaderText(apiVisa)
    );
  }
}
